import React from "react";
import { FormGroup, Input, Label, Spinner } from "reactstrap";

const BranchStaffSelect = ({
  label = "Custodian",
  optional = true,
  staff = [],
  staffLoading = false,
  value,
  onChange,
  emptyMessage = "No active staff are assigned to this branch.",
}) => (
  <FormGroup>
    <Label>{label}</Label>
    {staffLoading ? (
      <div className="py-1">
        <Spinner size="sm" color="primary" /> Loading staff…
      </div>
    ) : (
      <>
        <Input type="select" value={value} onChange={onChange} disabled={!staff.length && !optional}>
          {optional && <option value="">Select staff…</option>}
          {staff.map((member) => (
            <option key={member.id} value={member.id}>
              {member.full_name}
              {member.department_name ? ` · ${member.department_name}` : ""}
            </option>
          ))}
        </Input>
        {!staff.length && <small className="text-muted d-block mt-1">{emptyMessage}</small>}
      </>
    )}
  </FormGroup>
);

export default BranchStaffSelect;
